import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';
import { jsx as _jsx } from "react/jsx-runtime";
const apolloClient = createApolloClient();
const ApolloProviderContainer = ({
  children
}) => {
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: apolloClient,
    children: children
  });
};
export default ApolloProviderContainer;